exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "html,body,#app,.swiper{width:100%;height:100%;padding:0;margin:0;background-color:#f1f1f1}#app{overflow-y:auto}.result-img{width:100%;height:100%;-o-object-fit:contain;object-fit:contain}.top-tip{position:fixed;z-index:100;left:0;top:0;width:100%;line-height:40px;text-align:center;color:#e94c4c}\n", ""]);

// exports
